import RsaGestionePresenzeListPage from "./pages/RsaGestionePresenzeListPage.vue";

export default { RsaGestionePresenzeListPage };
